var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"dygraph",staticStyle:{"width":"100%","max-width":"100%","min-width":"100%"}})}
var staticRenderFns = []

export { render, staticRenderFns }